import Instense from "./Axios-config";
import axios from "axios";

export class PayrollRevision {
  private static cancelTokens: Record<string, any> = {};

  private static createCancelToken = (key: string) => {
    // Cancel previous token if exists
    if (PayrollRevision.cancelTokens[key]) {
      PayrollRevision.cancelTokens[key].cancel("Operation canceled due to new request.");
    }
    // Create and assign new cancel token
    PayrollRevision.cancelTokens[key] = axios.CancelToken.source();
    return PayrollRevision.cancelTokens[key].token;
  };

  public static SavePayrollRevision = async (req): Promise<any | null> => {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantID = storage?.tenantID || 0;
    const request: any = { ...req ,  TenantID: tenantID };
    const url = `/PayrollRevision/SavePayrollRevision`;

    return Instense.post(url, request, {
      cancelToken: this.createCancelToken("SavePayrollRevision"),
    }).then((response) => {
      let result = response.data;
      return result;
    });
  };

  public static GetPayrollRevision = async (req): Promise<any | null> => {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantID = storage?.tenantID || 0;

    const request: any = { ...req, TenantID: tenantID };
    const url = `/PayrollRevision/GetPayrollRevision`;

    return Instense.get(url, {
      cancelToken: this.createCancelToken("GetPayrollRevision"),
      params: request,
      paramsSerializer: (params) =>
        Object.entries(params)
          .map(([key, value]) =>
            Array.isArray(value)
              ? value.map((v) => `${key}=${v}`).join("&")
              : `${key}=${value}`
          )
          .join("&"),
    }).then((response) => response?.data || {});
  };

  public static GetPayrollRevisionLogs = async (req): Promise<any | null> => {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantID = storage?.tenantID || 0;

    const request: any = { ...req, TenantID: tenantID };
    const url = `/PayrollRevision/GetPayrollRevisionLogs`;

    return Instense.get(url, {
      cancelToken: this.createCancelToken("GetPayrollRevisionLogs"),
      params: request,
      paramsSerializer: (params) =>
        Object.entries(params)
          .map(([key, value]) =>
            Array.isArray(value)
              ? value.map((v) => `${key}=${v}`).join("&")
              : `${key}=${value}`
          )
          .join("&"),
    }).then((response) => response?.data || {});
  };

  public static GetPayrollRevisionEhidList = async (req): Promise<any | null> => {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantID = storage?.tenantID || 0;

    const request: any = { ...req, tenantId: tenantID };
    const url = `/PayrollRevision/GetEhidList`;

    return Instense.get(url, {
      cancelToken: this.createCancelToken("GetPayrollRevisionEhidList"),
      params: request,
    }).then((response) => response?.data || {});
  };


  public static GetTenantList = async (): Promise<any> => {
    const url = `/PayrollRevision/Get_TenantDetailsList`;
    return Instense.get(url).then((response) => {
      return response?.data;
    });
  };
}
